import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { useEffectOnce } from 'usehooks-ts';

import { companyUsersFetch, frontlineUsersFetch, servicersFetch } from './action';
import { selectFeatureUser } from './selector';

export const useCompanyUsersFetch = () => {
  const dispatch = useDispatch();
  const { companyUsers } = useSelector(selectFeatureUser);

  useEffectOnce(() => {
    if (!isEmpty(companyUsers)) return;
    dispatch(companyUsersFetch());
  });

  return companyUsers;
};

export const useFrontlineUsersFetch = () => {
  const dispatch = useDispatch();
  const { frontlineUsers } = useSelector(selectFeatureUser);

  useEffectOnce(() => {
    if (!isEmpty(frontlineUsers)) return;
    dispatch(frontlineUsersFetch());
  });

  return frontlineUsers;
};

export const useServicersFetch = () => {
  const dispatch = useDispatch();
  const { servicers } = useSelector(selectFeatureUser);

  useEffectOnce(() => {
    if (!isEmpty(servicers)) return;
    dispatch(servicersFetch());
  });

  return servicers;
}
